<template>
  <div class="work-list-block-component">
    <div class="title">学员作品</div>
    <work-list :next-start="nextStart"
               :works="works"
               :query="query"
               v-if="works.length > 0"
    />
    <div class="empty"
         v-else
    >
      暂无学员作品
    </div>
  </div>
</template>

<script>
  import WorkList from '@/pages/Work/components/WorkList';

  export default {
    name: 'ChallengeWorkListBlock',
    components: {
      WorkList,
    },
    props: {
      works: {
        type: Array,
        required: true,
      },
      nextStart: {
        type: Number,
        required: true,
      },
      targetId: {
        type: Number,
        required: true,
      },
      targetType: {
        type: String,
        required: true,
      },
    },
    computed: {
      query() {
        const { targetType, targetId } = this;
        return {
          targetType,
          targetId,
        };
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .work-list-block-component {
    background: @color-white;
    margin-top: @size-small;
  }

  .title {
    padding: @size-small @size-base;
    color: @color-text-base;
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    border-bottom: @border-base;
  }
</style>
